import { render, staticRenderFns } from "./GlobalFilter.vue?vue&type=template&id=0c7ab924&"
import script from "./GlobalFilter.vue?vue&type=script&lang=js&"
export * from "./GlobalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7ab924')) {
      api.createRecord('0c7ab924', component.options)
    } else {
      api.reload('0c7ab924', component.options)
    }
    module.hot.accept("./GlobalFilter.vue?vue&type=template&id=0c7ab924&", function () {
      api.rerender('0c7ab924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/GlobalFilter.vue"
export default component.exports